<ng-container *ngIf="retailPlace$ | async as retailPlace">
  <div data-qa="retail-place-name">
    {{ 'common.retail.place' | translate }} "{{ retailPlace.title }}"
  </div>
  <div class="retail-place-description">
    <span data-qa="retail-place-id">id: {{ retailPlace.id }}</span>
    <span data-qa="retail-place-address"
      >{{ 'common.address' | translate }}: {{ retailPlace.address }}</span
    >
  </div>
</ng-container>
